// removed by extract-text-webpack-plugin
module.exports = {"vpQuestionContainer":"vpQuestionContainer___39CAX","vpQuestionPanel":"vpQuestionPanel___3gYdL","vpProgressBar":"vpProgressBar___3JqOQ"};


//////////////////
// WEBPACK FOOTER
// ./src/components/CampaignLanding/CampaignQuestionContainer.module.less
// module id = 3763
// module chunks = 33